import PlusIcon from '@/assets/icons/plus-icon-n500.svg';

interface SidePanelAddToolProps {
  toolName: string;
  toolIcon: string;
  toolLoaderText: string;
  isButtonDisabled: boolean;
  onClick: () => void;
}

export const SidePanelAddTool = ({
  toolName,
  toolIcon,
  toolLoaderText,
  isButtonDisabled,
  onClick,
}: SidePanelAddToolProps) => {
  return (
    <button
      className="group flex h-[72px] w-full items-center justify-between gap-4 rounded-[8px] border border-N600 px-4 py-3 hover:bg-[#353336]"
      disabled={isButtonDisabled}
      onClick={onClick}
    >
      <div className="flex items-center gap-2 text-marveri-white">
        <img
          src={toolIcon}
          alt={toolName}
          className={`${isButtonDisabled && 'opacity-90 brightness-100 saturate-0'}`}
        />
        <span className="text-[16px]">{isButtonDisabled ? toolLoaderText : toolName}</span>
      </div>
      <div className="flex size-8 rounded-full bg-[#353336] p-[6px] group-hover:bg-[#454446]">
        <img src={PlusIcon} alt="plus" className="group-hover:filter-hover-filter" />
      </div>
    </button>
  );
};
